import { render, staticRenderFns } from "./TabUnidadeSolicitante.vue?vue&type=template&id=f6407246&"
import script from "./TabUnidadeSolicitante.vue?vue&type=script&lang=js&"
export * from "./TabUnidadeSolicitante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports